import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import focusOnInsert from 'garaje/modifiers/focus-on-insert';

interface AutofocusInputSignature {
  Args: {
    type?: string;
    value?: string;
    onInput?: (value: string) => void;
  };
  Element: HTMLInputElement;
}

export default class AutofocusInput extends Component<AutofocusInputSignature> {
  get type(): string {
    return this.args.type ?? 'text';
  }

  handleInput = (event: Event): void => {
    const target = event.currentTarget as HTMLInputElement;
    this.args.onInput?.(target.value);
  };

  <template>
    <input ...attributes value={{@value}} type={{this.type}} {{focusOnInsert}} {{on "input" this.handleInput}} />
  </template>
}
